import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebookF } from "@fortawesome/free-brands-svg-icons";

// Wrapper
const SocialIconsWrapper = styled.div<{ $isVisible: boolean }>`
  display: ${(props) => (props.$isVisible ? "flex" : "none")};
  justify-content: start;
  align-items: center;
  gap: 16px;

  @media (min-width: 1200px) {
    display: flex;
  }
`;

// Используем string | number и передаём как есть
const SocialLink = styled.a<{ $size: string | number }>`
  color: var(--text-color);
  transition: color 0.3s;

  &:hover {
    color: var(--button-bg);
  }

  svg {
    font-size: ${(props) => (typeof props.$size === "number" ? `${props.$size}px` : props.$size)};
  }
`;

interface SocialLinksProps {
  instagramUrl?: string;
  facebookUrl?: string;
  instagramSize?: number | string;
  facebookSize?: number | string;
  isVisible?: boolean;
}

const SocialLinks: React.FC<SocialLinksProps> = ({
  instagramUrl,
  facebookUrl,
  instagramSize = 24,
  facebookSize = 24,
  isVisible = true,
}) => {
  if (!instagramUrl && !facebookUrl) return null;

  return (
    <SocialIconsWrapper $isVisible={isVisible}>
      {instagramUrl && (
        <SocialLink
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          $size={instagramSize}
        >
          <FontAwesomeIcon icon={faInstagram} />
        </SocialLink>
      )}
      {facebookUrl && (
        <SocialLink
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          $size={facebookSize}
        >
          <FontAwesomeIcon icon={faFacebookF} />
        </SocialLink>
      )}
    </SocialIconsWrapper>
  );
};

export default SocialLinks;

